import { useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import BlogHero from './components/BlogHero';
import BlogContent from './components/BlogContent';

export default function BlogSurgeCapacity() {
  useEffect(() => {
    // Update meta tags
    document.title = 'Surging Without Hiring: How Outsourcing Layout Work Helps Vancouver Firms Stay Lean | Dinari Designs';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Learn how Vancouver construction firms use outsourced layout detailing to handle project surges without long-term hiring commitments in the Lower Mainland market.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'construction surge capacity, Vancouver layout services, scalable detailing, lean construction staffing, Lower Mainland contractors');
    }

    // Add Schema.org JSON-LD for Article
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: 'Surging Without Hiring: How Outsourcing Layout Work Helps Vancouver Firms Stay Lean',
      description: 'Learn how Vancouver construction firms use outsourced layout detailing to handle project surges without long-term hiring commitments in the Lower Mainland market.',
      author: {
        '@type': 'Organization',
        name: 'Dinari Designs',
      },
      publisher: {
        '@type': 'Organization',
        name: 'Dinari Designs',
        logo: {
          '@type': 'ImageObject',
          url: 'https://static.readdy.ai/image/f0c3f25d25166b296c2998ed1e07db56/4ed16d38f79ad8245b8fcfc88558374a.jfif',
        },
      },
      datePublished: '2026-01-20',
      dateModified: new Date().toISOString().split('T')[0],
    });

    if (!document.head.querySelector('script[data-schema="blog-surge-capacity"]')) {
      script.setAttribute('data-schema', 'blog-surge-capacity');
      document.head.appendChild(script);
    }

    return () => {
      const schemaScript = document.head.querySelector('script[data-schema="blog-surge-capacity"]');
      if (schemaScript) {
        schemaScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <BlogHero />
      <BlogContent />
      <Footer />
    </div>
  );
}
